import { MenuProps } from "@/layout/Navbar/Side/SideDrawer";

export const mainFasiliasNavMenus: MenuProps[] = [
  {
    title: "Meja Baca",
    path: "/baca"
  },
  {
    title: "Koleksi Cetak",
    path: "/koleksi-cetak"
  },
  {
    title: "Koleksi Elektronik",
    path: "/koleksi-elektronik"
  },
  {
    title: "Fasilitas Lainnya",
    path: "/fasilitas-lainnya"
  }
];